import { colors } from '@material-ui/core'

import theme from 'theme'

const DRAFT_STATUS_ID = 'draft'
const SCHEDULED_STATUS_ID = 'scheduled'
const INACTIVE_STATUS_ID = 'inactive'
const SENT_STATUS_ID = 'sending'

const STATUS_COLOR = {
  [DRAFT_STATUS_ID]: theme.palette.info.main,
  [SCHEDULED_STATUS_ID]: colors.yellow[600],
  [INACTIVE_STATUS_ID]: colors.blueGrey[400],
  [SENT_STATUS_ID]: theme.palette.success.main,
}

const ALL_TAB_VALUE = 'all'

const TABS = [
  { label: 'Todas', value: ALL_TAB_VALUE },
  { label: 'Rascunho', value: DRAFT_STATUS_ID },
  { label: 'Agendado', value: SCHEDULED_STATUS_ID },
  { label: 'Enviado', value: SENT_STATUS_ID },
]

const STATUS_LABELS = [
  {
    id: DRAFT_STATUS_ID,
    label: 'Rascunho',
    color: STATUS_COLOR[DRAFT_STATUS_ID],
  },
  {
    id: SCHEDULED_STATUS_ID,
    label: 'Agendado',
    color: STATUS_COLOR[SCHEDULED_STATUS_ID],
  },
  {
    id: INACTIVE_STATUS_ID,
    label: 'Inativa',
    color: STATUS_COLOR[INACTIVE_STATUS_ID],
  },
  { id: SENT_STATUS_ID, label: 'Enviado', color: STATUS_COLOR[SENT_STATUS_ID] },
]

const SENDING_STATUS_ID = 'sending'
const FINISHED_STATUS_ID = 'finished'
const CANCELLED_STATUS_ID = 'cancelled'
const FAILED_STATUS_ID = 'failed'

const STATUS_LABEL = {
  draft: 'Rascunho',
  scheduled: 'Agendada',
  sending: 'Enviado',
  finished: 'Finalizada',
  cancelled: 'Cancelada',
  failed: 'Falhou',
}

const PARTICIPANT_DISPLAY_STATUS_LABEL = {
  compromised: 'Comprometido',
  alert: 'Alerta',
  sent: 'Entregue',
  pending: 'Pendente',
  failed: 'Falhou',
}

const PARTICIPANT_STATUS_COLOR = {
  sent: 'success',
  compromised: 'error',
  alert: 'error',
  pending: 'pending',
  failed: 'error',
}

const PLATFORM_DEFAULT_PARTICIPANT_LIMIT = 50

const REPORT_TYPES = {
  GENERAL: 'reportGeneral',
  BY_CAMPAIGN: 'reportByCampaign',
}

const DISPATCH_IMMEDIATE = 'immediate'
const DISPATCH_SCHEDULED = 'timed'
const DISPATCH_LATER = 'pending'

const DISPATCH_OPTIONS = [
  { value: DISPATCH_IMMEDIATE, label: 'Disparar imediatamente' },
  { value: DISPATCH_SCHEDULED, label: 'Agendar disparo' },
  { value: DISPATCH_LATER, label: 'Disparar depois' },
]

const FORM_STEPS = [
  'Configuração',
  'Participantes',
  'Modelo',
  'Agendamento',
  'Confirmação',
]

const FORM_STEPS_VIEW = ['Detalhes', ...FORM_STEPS]

const FORM_STEP_LABELS = [
  'Avançar',
  'Avançar',
  'Avançar',
  'Avançar',
  'Finalizar',
]

const ALLOWLIST_GUIDES = [
  {
    label: 'Guia de Allowlist para Microsoft/Office 365',
    href: 'https://learn.microsoft.com/pt-br/defender-office-365/create-safe-sender-lists-in-office-365',
  },
  {
    label: 'Guia de Allowlist para GSuite/Google Apps',
    href: 'https://knowledge.workspace.google.com/admin/gmail/advanced/add-ip-addresses-to-allowlists-in-gmail?hl=pt-br',
  },
]

const PERMISSIONS_REMINDER_OPTIONS = {
  ALREADY_CONFIGURED: 'already_configured',
  PROCEED_WITHOUT: 'proceed_without',
}

const TUTORIAL_CARDS = [
  {
    title: 'Simule campanhas de phishing',
    description:
      'Crie campanhas de simulação de phishing para testar o nível de conscientização dos colaboradores da sua empresa. Escolha modelos realistas de e-mails maliciosos e envie para os participantes selecionados.',
  },
  {
    title: 'Configure sua lista de permissões',
    description:
      'Plataformas de treinamento em conscientização de segurança exigem que você adicione nossos endereços à lista de permissões (allowlist) para garantir a entrega dos e-mails. Sem isso, seu provedor de e-mail pode bloquear nossos e-mails de phishing simulado ou de treinamento. Veja nossos guias que ajudam você a configurar isso em poucos passos!',
  },
]

const MONTH_LABELS = [
  'Jan',
  'Fev',
  'Mar',
  'Abr',
  'Mai',
  'Jun',
  'Jul',
  'Ago',
  'Set',
  'Out',
  'Nov',
  'Dez',
]

const DIFFICULTY_MAP = {
  easy: { label: 'Fácil', color: 'easy' },
  medium: { label: 'Médio', color: 'medium' },
  complex: { label: 'Complexo', color: 'hard' },
}

const PLATFORM_DEFAULT_SMTP_OPTION = {
  id: null,
  label: 'Padrão da plataforma (dponet.com.br)',
}

const BANNER_CONTENT = {
  noCampaigns: {
    title: 'Sua organização ainda não realizou nenhuma simulação de phishing.',
    subtitle:
      'Mantenha suas campanhas em dia para garantir a segurança da sua equipe.',
  },
  highClickRate: {
    title:
      '25% dos colaboradores clicaram no link falso nas simulações de phishing.',
    subtitle:
      'Mantenha suas campanhas em dia para garantir a segurança da sua equipe.',
  },
  default: {
    title: 'Sua organização está realizando simulações de phishing.',
    subtitle:
      'Continue monitorando as campanhas para garantir a segurança da sua equipe.',
  },
}

const CARDS = [
  {
    number: '01',
    title: 'Remetente suspeito',
    description:
      'Golpes simulam endereços conhecidos com pequenas variações. Verifique sempre o domínio completo do e-mail antes de clicar em qualquer link ou baixar anexos.',
  },
  {
    number: '02',
    title: 'Urgência artificial',
    description:
      'Mensagens de phishing criam pressão para agir rápido. Desconfie de prazos curtos, ameaças de bloqueio de conta ou promessas de prêmios inesperados.',
  },
  {
    number: '03',
    title: 'Links disfarçados',
    description:
      'Passe o mouse sobre o link antes de clicar. Se o endereço não bater com o site esperado, não acesse — mesmo que o visual da página pareça legítimo.',
  },
]

export default {
  ALL_TAB_VALUE,
  ALLOWLIST_GUIDES,
  BANNER_CONTENT,
  CANCELLED_STATUS_ID,
  CARDS,
  DIFFICULTY_MAP,
  DISPATCH_IMMEDIATE,
  DISPATCH_LATER,
  DISPATCH_OPTIONS,
  DISPATCH_SCHEDULED,
  DRAFT_STATUS_ID,
  FAILED_STATUS_ID,
  FINISHED_STATUS_ID,
  FORM_STEP_LABELS,
  FORM_STEPS,
  FORM_STEPS_VIEW,
  INACTIVE_STATUS_ID,
  MONTH_LABELS,
  PARTICIPANT_DISPLAY_STATUS_LABEL,
  PARTICIPANT_STATUS_COLOR,
  PERMISSIONS_REMINDER_OPTIONS,
  PLATFORM_DEFAULT_PARTICIPANT_LIMIT,
  PLATFORM_DEFAULT_SMTP_OPTION,
  REPORT_TYPES,
  SCHEDULED_STATUS_ID,
  SENDING_STATUS_ID,
  SENT_STATUS_ID,
  STATUS_COLOR,
  STATUS_LABEL,
  STATUS_LABELS,
  TABS,
  TUTORIAL_CARDS,
}
